// extracted by mini-css-extract-plugin
module.exports = {"seriesRatingWrapper":"BA","ratingTooltip":"BB"};